import { createSelector } from 'reselect';

import getCurrentUser from '@core/reducers/user/selectors/getCurrentUser';
import getAgeValidationBirth from '@user/selectors/getAgeValidationBirth';
import getValidationIsOfAge from '@user/selectors/getValidationIsOfAge';
import getCountryAgeRestriction from '@location/selectors/getCountryAgeRestriction';
import { AGE_VALIDATION_TYPE } from '@shopDetails/HOCs/WithAgeValidation/constants';
import { isDateLegalAge } from '@utils/date';

import isString from '@commons/utils/string/isString';

const getValidationAge = createSelector(
  getCurrentUser,
  getAgeValidationBirth,
  getValidationIsOfAge,
  getCountryAgeRestriction,
  (user, ageValidationBirth, isOfAge, ageRestriction) => {
    const { ageValidationStoringAllowed, ageValidationType, ageOfMajority } =
      ageRestriction || {};

    let userIsLegalAge = false;
    if (ageValidationStoringAllowed) {
      if (ageValidationType === AGE_VALIDATION_TYPE.DATE_OF_BIRTH) {
        userIsLegalAge =
          user?.birth &&
          isString(user.birth) &&
          isDateLegalAge(user.birth, ageOfMajority);
      } else if (ageValidationType === AGE_VALIDATION_TYPE.IS_OF_AGE) {
        userIsLegalAge = user?.isOfAge;
      }
    }

    const hasValidated =
      isOfAge ||
      (ageValidationBirth && isDateLegalAge(ageValidationBirth, ageOfMajority));

    if (userIsLegalAge || hasValidated) return false;

    return true;
  },
);

export default getValidationAge;
